export default function AboutPage() {
  return <div>About this project</div>;
}
